import store from '@/store';
import axios from 'axios';
import NProgress from 'nprogress';

axios.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

axios.interceptors.response.use(
  (response) => {
    store.dispatch('loading/hideLoading');
    NProgress.done();
    return response;
  },
  function (error) {
    store.dispatch('loading/hideLoading');
    NProgress.done();
    return Promise.reject(error);
  }
);

export const BackendAPI = (method, path, data = {}) => {
  checkLocalSession(path);

  const axiosDefaultSetting = defaultAxiosDefaultSetting(method, path, data);
  axios.timeout = 1000 * 120; // Wait for 120s

  return axios(axiosDefaultSetting);
};

export const BackendDownloadFileAPI = (method, path, data = {}) => {
  checkLocalSession(path);

  let axiosDefaultSetting = defaultAxiosDefaultSetting(method, path, data);
  axiosDefaultSetting.responseType = 'arraybuffer';
  axiosDefaultSetting.headers = {
    Accept: 'application/octet-stream',
  };

  return axios(axiosDefaultSetting);
};

const defaultAxiosDefaultSetting = (method, path, data = {}) => {
  let axiosSetting = {
    method: method,
    url: process.env.VUE_APP_BACKEND_END_POINT + path,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  // Set request parameter or body
  if (method == 'get') {
    axiosSetting.params = data;
  } else {
    axiosSetting.data = data;
  }

  return axiosSetting;
};

const checkLocalSession = (path) => {
  if (path == 'login') return;

  return store.dispatch('auth/restoreSession');
};
